<template>
  <span class="d-inline-flex">
    <AppShowCompetitionTag
      v-for="(chipTag, index) in chipTags"
      :key="index"
      :competition-tag="chipTag"
    />
  </span>
</template>
<script>
import gql from "fraql";
export default {
  name: "AppShowCompetitionTagsGroup",
  fragments: {
    competitionFields: gql`
      fragment _ on Competition {
        resultsUnlisted
        isHighlighted
        isGrandPrix
        displayChips
        isCupFinal
      }
    `
  }
};
</script>
<script setup>
import { toRefs, computed } from "vue";
import { useTranslation } from "i18next-vue";

import AppShowCompetitionTag from "./AppShowCompetitionTag.vue";

const props = defineProps({
  competition: {
    type: Object,
    required: true
  }
});

const { competition } = toRefs(props);
const { t } = useTranslation();
const chipTags = computed(() => {
  const c = competition.value;
  const chips = [];

  if (
    c.resultsUnlisted &&
    c.allowedMutations.includes("competitionUpdateResultsUnlisted")
  ) {
    chips.push({
      ariaLabel: t(
        "common:competition.resultsUnlisted.footnote.text",
        "Unlisted result"
      ),
      icon: "$iconEyeSlash",
      style: {
        color: "black",
        class: "bg-transparent"
      }
    });
  }

  if (c.isHighlighted) {
    chips.push({
      ariaLabel: t(
        "common:competition.isHighlighted.footnote.text",
        "Important competition"
      ),
      icon: "$iconStar",
      style: {
        color: "star",
        class: ""
      }
    });
  }

  if (c.isGrandPrix) {
    chips.push({
      ariaLabel: t(
        "common:competition.isGrandPrix.footnote.text",
        "A Grand Prix competition"
      ),
      iconText: t("common:competition.isGrandPrix.label", "GP"),
      style: {
        class: "bg-accent text-white"
      }
    });
  }

  if (c.isCupFinal) {
    chips.push({
      ariaLabel: t("common:competition.isCupFinal.footnote.text", "Cup final"),
      icon: "$iconTrophy",
      style: {
        color: "black",
        class: "bg-transparent"
      }
    });
  }

  (c.displayChips ?? []).forEach(chip => {
    switch (chip) {
      case "FeiEventUsingInvitationSystem":
        chips.push({
          ariaLabel: t(
            "common:competition.isInvitationSystemEvent.footnote.text",
            "Event using the Invitation System "
          ),
          iconText: t("common:competition.isInvitationSystemEvent.label", "IS"),
          style: {
            class: "bg-competitionInvitationSystemTag text-white"
          }
        });
        break;
      case "FeiEventWithStandardEntryProcedure":
        chips.push({
          ariaLabel: t(
            "common:competition.standardEntryProcedure.footnote.text",
            "Event with standard entry procedure"
          ),
          iconText: t("common:competition.standardEntryProcedure.label", "SE"),
          style: {
            class: "bg-competitionStandardProcedureTag text-white"
          }
        });
        return;
      case "FeiEventWithUnlimitedEntries":
        chips.push({
          ariaLabel: t(
            "common:competition.unlimitedEntries.footnote.text",
            "Event with unlimited entries"
          ),
          iconText: t("common:competition.unlimitedEntries.label", "UL"),
          style: {
            class: "bg-competitionUnlimitedEntriesTag text-white"
          }
        });
        break;
      case "FeiEventWithAirTransport":
        chips.push({
          ariaLabel: t(
            "common:competition.airplaneTransportation.footnote.text",
            "Air transport and/or early closing date"
          ),
          icon: "$iconPlane",
          style: {
            color: "white",
            class: "bg-competitionAirTransportTag"
          }
        });
        break;
    }
  });

  return chips;
});
</script>
